import { create } from 'zustand';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  id: string;
  message: string;
  severity: NotificationSeverity;
}

interface NotificationStore {
  notifications: Notification[];
  addNotification: (message: string, severity: NotificationSeverity) => void;
  removeNotification: (id: string) => void;
  clearAll: () => void;
}

const generateId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  addNotification: (message, severity) =>
    set((state) => ({
      notifications: [...state.notifications, { id: generateId(), message, severity }],
    })),
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  clearAll: () => set({ notifications: [] }),
}));

export const notify = {
  success: (message: string) =>
    useNotificationStore.getState().addNotification(message, 'success'),
  error: (message: string) =>
    useNotificationStore.getState().addNotification(message, 'error'),
  warning: (message: string) =>
    useNotificationStore.getState().addNotification(message, 'warning'),
  info: (message: string) =>
    useNotificationStore.getState().addNotification(message, 'info'),
};
